import { combineReducers } from 'redux';

import queryParams from './shared/reducers/queryParamsReducer';

export default combineReducers({
  queryParams
});
